import React from 'react'
import PrintView from '../../components/PrintView/PrintView'
import image from '../../assets/images/prince-product.jpg'

const HuntGoals = () => {
  return <PrintView
  title='I don’t set goals. I hunt them down'
  heading='I don’t set goals. I hunt them down'
  content='“ I’m HPM 08 , The most famous leopard in Horton Plains.” This is a detailed image with high resolution and was absolutely lucky to have captured this well grown male leopard in this angle.'
  printImage={image}
 />
}

export default HuntGoals